const prefix = 'fasr';
const iconName = 'palette';
const width = 512;
const height = 512;
const aliases = [127912];
const unicode = 'f53f';
const svgPathData = 'M464 256v16H355.9c-64 0-115.9 51.9-115.9 115.9c0 20.2 5.3 39.9 15.1 57.2L237 463.1C131 453.5 48 364.5 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208zM320 448l-12.1-12.1c-12.7-12.7-19.9-30-19.9-48c0-37.5 30.4-67.9 67.9-67.9H464h48V272 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512l30.1-30.1L320 448zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
